import classNames from 'classnames'

import { Headline2 } from '../../Headline2'
import { MODAL_HEADER_VARIANT } from '../Modal.constants'
import { ModalCloseButton } from '../ModalCloseButton'
import { ModalMinimizeButton } from '../ModalMinimizeButton'
import { ModalOpenInNewWindowButton } from '../ModalOpenInNewWindowButton'
import { ModalResizeButton } from '../ModalResizeButton'

import * as styles from './Header.module.css'

function Header({
  actions,
  className,
  headlineClassName = styles.headerText,
  isFullScreen,
  isSkeleton,
  openInNewWindowLink,
  persistentActions,
  text,
  variant = MODAL_HEADER_VARIANT.EDIT,
  onClose,
  onMinimize,
  onResize,
}) {
  const headerClassName = classNames(styles.header, styles[variant], className)

  return (
    <div className={headerClassName}>
      <Headline2 className={headlineClassName} isSkeleton={isSkeleton}>
        {text}
      </Headline2>
      <div className={styles.actions}>
        {actions && !isSkeleton ? actions : null}
        {onMinimize && !isSkeleton ? (
          <ModalMinimizeButton onClick={onMinimize} />
        ) : null}
        {openInNewWindowLink && !isSkeleton ? (
          <ModalOpenInNewWindowButton link={openInNewWindowLink} />
        ) : null}
        {onResize && !isSkeleton ? (
          <ModalResizeButton isFullScreen={isFullScreen} onClick={onResize} />
        ) : null}
        {onClose && !isSkeleton ? <ModalCloseButton onClose={onClose} /> : null}
        {persistentActions}
      </div>
    </div>
  )
}

export default Header
